export default "__VITE_ASSET___2c_u9ab__"